import { useState, useEffect } from 'react';

export const useFormData = (initialState, storageKey = null) => {
    const [formData, setFormData] = useState(initialState);

    // Load from localStorage if storageKey is provided
    useEffect(() => {
        if (storageKey) {
            const savedData = JSON.parse(localStorage.getItem(storageKey) || 'null');
            if (savedData) setFormData(savedData);
        }
    }, [storageKey]);

    // Save to localStorage when data changes
    useEffect(() => {
        if (storageKey) {
            localStorage.setItem(storageKey, JSON.stringify(formData));
        }
    }, [formData, storageKey]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const resetForm = () => setFormData(initialState);

    return { formData, setFormData, handleChange, resetForm };
};
